import { Helpers } from '../../helpers';
import { IConstraintDrillFracInterference } from '../../interfaces/iconstraint-drill-frac-interference';
import { ConstraintDrillFracInterferenceDetail } from '../constraint-drill-frac-interference-detail';
import { Scenario } from '../scenario';

export class ConstraintDrillFracInterferenceBase {
  ConstraintDrillFracInterferenceId: number;
  ScenarioId: number;
  EffectiveStartDate: Date | null;
  EffectiveEndDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintDrillFracInterferenceDetails_ConstraintDrillFracInterference?: Array<ConstraintDrillFracInterferenceDetail> | null;
  Scenario?: Scenario;

  constructor(item?: IConstraintDrillFracInterference) {
    if (item) {

      this.ConstraintDrillFracInterferenceId = item.ConstraintDrillFracInterferenceId;
      this.ScenarioId = item.ScenarioId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveEndDate = item.EffectiveEndDate ? new Date(item.EffectiveEndDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintDrillFracInterferenceDetails_ConstraintDrillFracInterference = Helpers.createClassArray(ConstraintDrillFracInterferenceDetail, item.ConstraintDrillFracInterferenceDetails_ConstraintDrillFracInterference);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}